import { FC, useId } from 'react';
import { Link } from 'react-router-dom';
import styles from './Logo.module.scss';

export interface LogoProps {
  variant?: 'dark' | 'light';
  className?: string;
}

const Logo: FC<LogoProps> = ({
  variant = 'dark',
  className = '',
}) => {
  const gradId = useId();

  return (
    <Link
      to="/"
      className={`${styles.logoLink} ${className}`.trim()}
      aria-label="Pulse - Building Information Platform"
    >
      <svg
        className={styles.logoSvg}
        viewBox="0 0 175 44"
        aria-hidden="true"
        width="160"
        height="40"
      >
        <defs>
          <linearGradient id={gradId} x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="var(--color-logo-teal)" />
            <stop offset="100%" stopColor="var(--color-logo-teal-dark)" />
          </linearGradient>
        </defs>
        <path
          d="M10 24h10l5-6 7 15 8-27 8 21 5-7h11"
          fill="none"
          stroke={`url(#${gradId})`}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="10" cy="24" r="2.2" fill="var(--color-logo-teal)" />
        <text
          x="82"
          y="31"
          fontFamily="Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          fontWeight="760"
          fontSize="24"
          letterSpacing="-0.8px"
          fill={variant === 'dark' ? 'var(--color-text-primary)' : 'var(--color-text-inverse)'}
        >
          Pulse
        </text>
      </svg>
    </Link>
  );
};

export default Logo;
